module.exports = __webpack_public_path__ + "img/wraning_icon.b1a63a56.png";